"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _deepmerge2 = require("deepmerge");

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useReactlytics = function useReactlytics(overrideAnalytics) {
  var oldAnalytics = (0, _react.useContext)(_context.default);
  var mergedAnalytics = (0, _react.useMemo)(function () {
    var _deepmerge = (0, _deepmerge2.all)([oldAnalytics, overrideAnalytics || {}]),
        __originalTrack = _deepmerge.__originalTrack,
        localContext = _objectWithoutProperties(_deepmerge, ["__originalTrack"]);

    if (!__originalTrack) {
      return localContext;
    }

    var track = !localContext.disable // Need reference to original track to avoid multiple enhancement of track
    ? function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return __originalTrack((0, _deepmerge2.all)([localContext, options]));
    } : function () {};
    return (0, _deepmerge2.all)([localContext, {
      track: track
    }]);
  }, [oldAnalytics, overrideAnalytics]);
  return mergedAnalytics;
};

var _default = useReactlytics;
exports.default = _default;